import Icon from '../components/Icon.vue'

Icon.register({
  'file-video': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M384 121.9V128H256V0H262.1C268.4 0 274.5 2.5 279 7L377 105A24-24 0 0 0 384 121.9zM224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM320 280V392C320 413.4 294.1 424 279 408.9L224 353.9V392C224 405.3 213.3 416 200 416H88C74.7 416 64 405.3 64 392V280C64 266.7 74.7 256 88 256H200C213.3 256 224 266.7 224 280V318.1L279 263C294 248 320 258.6 320 280z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-video.js
// module id = nMSJ
// module chunks = 144